import moment from 'moment/moment';

const METRIC_LABEL_MAP = {
  accuracy: 'Accuracy',
  resolved_with_ai: 'Requests Resolved with AI',
  subdomain_resolved_with_ai: 'Requests Resolved with AI',
  bad_suggestions: 'Bad Suggestions Reported',
  subdomain_bad_suggestions: 'Bad Suggestions Reported',
  response_time: 'Average Response Time',
  subdomain_response_time: 'Average Response Time',
  first_response_time: 'Average First Response Time',
  subdomain_first_response_time: 'Average First Response Time',
};

// Chart labels keyed by the analytics API's metric names.
export const METRIC_LABELS: Record<string, string> = METRIC_LABEL_MAP;

const constants = {
  ...METRIC_LABEL_MAP,
  initialRequest: {
    project_id: null as number | null,
    date_range: 'day',
    time_axis: 'minutes',
    start_date: moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    metrics: [
      // 'first_response_time',
      // 'response_time',
      // 'resolved_with_ai',
      // 'bad_suggestions',
      'accuracy',
      'subdomain_response_time',
      'subdomain_bad_suggestions',
      'subdomain_first_response_time',
      'subdomain_resolved_with_ai',
    ],
    // CRM user ids.
    agents: [] as (string | number)[],
    data_visualization: 'linear',
  },
  personal_metrics: [
    'accuracy',
    'first_response_time',
    'response_time',
    'resolved_with_ai',
    'bad_suggestions',
  ],
  subdomain_metrics: [
    'accuracy',
    'subdomain_response_time',
    'subdomain_bad_suggestions',
    'subdomain_first_response_time',
    'subdomain_resolved_with_ai',
  ],
  colors: [
    '#6257DA',
    '#F01C42',
    '#FFF500',
    '#00AE84',
    '#FF05C8',
    '#1400FF',
    '#FFB72C',
    '#33F932',
    '#AA20FF',
    '#9A7B4D',
    '#8D8B89',
    '#A5DF00',
    '#FF9CB3',
    '#009FD1',
    '#F86D1F',
  ],
};

export default constants;
